import * as ActionType from "./supportChat.type";

const initialState = {
  conversations: [],
  totalConversations: 0,
  conversationDetails: null,
  messages: [],
  stats: null,
  isUserTyping: false,
  typingUserId: null,
};

export const supportChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_SUPPORT_CONVERSATIONS:
      return {
        ...state,
        conversations: action.payload.data,
        totalConversations: action.payload.total,
        stats: action.payload.stats || state.stats,
      };

    case ActionType.GET_SUPPORT_CONVERSATION_DETAILS:
      return {
        ...state,
        conversationDetails: action.payload.conversation,
        messages: action.payload.messages,
      };

    case ActionType.UPDATE_SUPPORT_STATUS:
    case ActionType.UPDATE_SUPPORT_PRIORITY:
    case ActionType.ASSIGN_AGENT:
    case ActionType.ADD_INTERNAL_NOTE:
      return {
        ...state,
        conversations: state.conversations.map((conv) => {
          if (conv._id === action.payload.id) return action.payload.data;
          else return conv;
        }),
        conversationDetails:
          state.conversationDetails?._id === action.payload.id
            ? action.payload.data
            : state.conversationDetails,
      };

    case ActionType.SEND_SUPPORT_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };

    case ActionType.DELETE_SUPPORT_MESSAGE:
      return {
        ...state,
        messages: state.messages.filter((msg) => msg._id !== action.payload),
      };

    case ActionType.GET_SUPPORT_STATS:
      return {
        ...state,
        stats: action.payload,
      };

    case ActionType.CLEAR_SUPPORT_CONVERSATION_DETAILS:
      return {
        ...state,
        conversationDetails: null,
        messages: [],
      };

    case ActionType.MARK_SUPPORT_READ:
      return {
        ...state,
        conversations: state.conversations.map((conv) => {
          if (conv._id === action.payload) {
            return { ...conv, supportUnreadCount: 0 };
          }
          return conv;
        }),
        conversationDetails:
          state.conversationDetails?._id === action.payload
            ? { ...state.conversationDetails, supportUnreadCount: 0 }
            : state.conversationDetails,
      };

    case ActionType.RECEIVE_SUPPORT_MESSAGE_VIA_SOCKET:
      // Check if message already exists to prevent duplicates
      const messageExists = state.messages.some(
        (msg) => msg._id === action.payload._id
      );
      if (messageExists) {
        return state;
      }
      // Only add if it's for the current conversation
      if (
        state.conversationDetails &&
        state.conversationDetails._id === action.payload.conversation
      ) {
        return {
          ...state,
          messages: [...state.messages, action.payload],
        };
      }
      return state;

    case ActionType.SET_USER_TYPING:
      return {
        ...state,
        isUserTyping: action.payload.isTyping,
        typingUserId: action.payload.participantId,
      };

    case ActionType.CREATE_SUPPORT_CONVERSATION:
      return {
        ...state,
        conversations: [action.payload, ...state.conversations],
        totalConversations: state.totalConversations + 1,
      };

    default:
      return state;
  }
};
